import React, { useMemo } from "react"; 
import ActionMenu, { Action } from "../../../../components/ui/materialui/actionMenu";
import { useToast } from "../../../../hooks/useToast";
import { ClientesCesantesDTO } from "../models/clientesCesantes";
import EditIcon from "@mui/icons-material/Edit";
import { usePermissions } from "../../../../components/auth/ProtectedRoute"; 
import { TipoFuncionalidad } from "../../../../utils/enums"; 

interface IProps {
    cesanteEditar: ClientesCesantesDTO;
    controlTabla: any;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
    setcesanteEditar: React.Dispatch<React.SetStateAction<ClientesCesantesDTO | undefined>>;
}

const AccionesClientesCesantes = ({ cesanteEditar, controlTabla, setModalDetalle, setcesanteEditar }: IProps) => {
    const { addToast } = useToast();
    const { hasPermission } = usePermissions(); 

    const handleEditarClick = () => {
        setcesanteEditar(cesanteEditar);
        setModalDetalle(true);
    }

    const actions = useMemo<Action[]>(() => {
        const items: Action[] = [];

        if (!hasPermission(TipoFuncionalidad.Cobranza_adm_cesantes)) {
            return items; 
        }

        items.push({ 
            label: "Modificar", 
            icon: <EditIcon fontSize="small" />, 
            onClick: handleEditarClick 
        });

        return items;
    }, [hasPermission, cesanteEditar]); 

    return (
        <>
            {actions.length > 0 && <ActionMenu actions={actions} />}
        </>
    );
}

export default AccionesClientesCesantes;